/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as GuardRouteImport } from './routes/_guard'
import { Route as ComingSoonRouteImport } from './routes/coming-soon'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as UiRouteImport } from './routes/ui'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthRegisterRouteImport } from './routes/_auth/register'
import { Route as GuardIndexRouteImport } from './routes/_guard/index'
import { Route as BillingCallbackRouteImport } from './routes/billing/callback'
import { Route as CheckoutTokenRouteImport } from './routes/checkout/$token'
import { Route as InstagramCallbackRouteImport } from './routes/instagram/callback'
import { Route as InviteTokenRouteImport } from './routes/invite/$token'
import { Route as TrackUuidRouteImport } from './routes/track/$uuid'
import { Route as AuthOtpIndexRouteImport } from './routes/_auth/otp/index'
import { Route as AuthOtpVerifyRouteImport } from './routes/_auth/otp/verify'
import { Route as GuardBillingIndexRouteImport } from './routes/_guard/billing/index'
import { Route as GuardCustomersIndexRouteImport } from './routes/_guard/customers/index'
import { Route as GuardOrdersIndexRouteImport } from './routes/_guard/orders/index'
import { Route as GuardOrdersOrderIdRouteImport } from './routes/_guard/orders/$orderId'
import { Route as GuardOrdersCreateRouteImport } from './routes/_guard/orders/create'
import { Route as GuardProductsIndexRouteImport } from './routes/_guard/products/index'
import { Route as GuardProductsCreateRouteImport } from './routes/_guard/products/create'
import { Route as GuardProfileIndexRouteImport } from './routes/_guard/profile/index'
import { Route as GuardSettingsIndexRouteImport } from './routes/_guard/settings/index'
import { Route as GuardShopsCreateRouteImport } from './routes/_guard/shops/create'
import { Route as GuardShopsInstagramRouteImport } from './routes/_guard/shops/instagram'
import { Route as GuardProductsProductIdEditRouteImport } from './routes/_guard/products/$productId/edit'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const GuardRoute = GuardRouteImport.update({
  id: '/_guard',
  getParentRoute: () => rootRouteImport,
} as any)
const ComingSoonRoute = ComingSoonRouteImport.update({
  id: '/coming-soon',
  path: '/coming-soon',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const UiRoute = UiRouteImport.update({
  id: '/ui',
  path: '/ui',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRoute,
} as any)
const GuardIndexRoute = GuardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => GuardRoute,
} as any)
const BillingCallbackRoute = BillingCallbackRouteImport.update({
  id: '/billing/callback',
  path: '/billing/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutTokenRoute = CheckoutTokenRouteImport.update({
  id: '/checkout/$token',
  path: '/checkout/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const InstagramCallbackRoute = InstagramCallbackRouteImport.update({
  id: '/instagram/callback',
  path: '/instagram/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const TrackUuidRoute = TrackUuidRouteImport.update({
  id: '/track/$uuid',
  path: '/track/$uuid',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthOtpIndexRoute = AuthOtpIndexRouteImport.update({
  id: '/otp/',
  path: '/otp/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOtpVerifyRoute = AuthOtpVerifyRouteImport.update({
  id: '/otp/verify',
  path: '/otp/verify',
  getParentRoute: () => AuthRoute,
} as any)
const GuardBillingIndexRoute = GuardBillingIndexRouteImport.update({
  id: '/billing/',
  path: '/billing/',
  getParentRoute: () => GuardRoute,
} as any)
const GuardCustomersIndexRoute = GuardCustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => GuardRoute,
} as any)
const GuardOrdersIndexRoute = GuardOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => GuardRoute,
} as any)
const GuardOrdersOrderIdRoute = GuardOrdersOrderIdRouteImport.update({
  id: '/orders/$orderId',
  path: '/orders/$orderId',
  getParentRoute: () => GuardRoute,
} as any)
const GuardOrdersCreateRoute = GuardOrdersCreateRouteImport.update({
  id: '/orders/create',
  path: '/orders/create',
  getParentRoute: () => GuardRoute,
} as any)
const GuardProductsIndexRoute = GuardProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => GuardRoute,
} as any)
const GuardProductsCreateRoute = GuardProductsCreateRouteImport.update({
  id: '/products/create',
  path: '/products/create',
  getParentRoute: () => GuardRoute,
} as any)
const GuardProfileIndexRoute = GuardProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => GuardRoute,
} as any)
const GuardSettingsIndexRoute = GuardSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => GuardRoute,
} as any)
const GuardShopsCreateRoute = GuardShopsCreateRouteImport.update({
  id: '/shops/create',
  path: '/shops/create',
  getParentRoute: () => GuardRoute,
} as any)
const GuardShopsInstagramRoute = GuardShopsInstagramRouteImport.update({
  id: '/shops/instagram',
  path: '/shops/instagram',
  getParentRoute: () => GuardRoute,
} as any)
const GuardProductsProductIdEditRoute =
  GuardProductsProductIdEditRouteImport.update({
    id: '/products/$productId/edit',
    path: '/products/$productId/edit',
    getParentRoute: () => GuardRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof GuardIndexRoute
  '/coming-soon': typeof ComingSoonRoute
  '/terms': typeof TermsRoute
  '/ui': typeof UiRoute
  '/login': typeof AuthLoginRoute
  '/register': typeof AuthRegisterRoute
  '/billing/callback': typeof BillingCallbackRoute
  '/checkout/$token': typeof CheckoutTokenRoute
  '/instagram/callback': typeof InstagramCallbackRoute
  '/invite/$token': typeof InviteTokenRoute
  '/track/$uuid': typeof TrackUuidRoute
  '/otp/verify': typeof AuthOtpVerifyRoute
  '/orders/$orderId': typeof GuardOrdersOrderIdRoute
  '/orders/create': typeof GuardOrdersCreateRoute
  '/products/create': typeof GuardProductsCreateRoute
  '/shops/create': typeof GuardShopsCreateRoute
  '/shops/instagram': typeof GuardShopsInstagramRoute
  '/otp/': typeof AuthOtpIndexRoute
  '/billing/': typeof GuardBillingIndexRoute
  '/customers/': typeof GuardCustomersIndexRoute
  '/orders/': typeof GuardOrdersIndexRoute
  '/products/': typeof GuardProductsIndexRoute
  '/profile/': typeof GuardProfileIndexRoute
  '/settings/': typeof GuardSettingsIndexRoute
  '/products/$productId/edit': typeof GuardProductsProductIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof GuardIndexRoute
  '/coming-soon': typeof ComingSoonRoute
  '/terms': typeof TermsRoute
  '/ui': typeof UiRoute
  '/login': typeof AuthLoginRoute
  '/register': typeof AuthRegisterRoute
  '/billing/callback': typeof BillingCallbackRoute
  '/checkout/$token': typeof CheckoutTokenRoute
  '/instagram/callback': typeof InstagramCallbackRoute
  '/invite/$token': typeof InviteTokenRoute
  '/track/$uuid': typeof TrackUuidRoute
  '/otp/verify': typeof AuthOtpVerifyRoute
  '/orders/$orderId': typeof GuardOrdersOrderIdRoute
  '/orders/create': typeof GuardOrdersCreateRoute
  '/products/create': typeof GuardProductsCreateRoute
  '/shops/create': typeof GuardShopsCreateRoute
  '/shops/instagram': typeof GuardShopsInstagramRoute
  '/otp': typeof AuthOtpIndexRoute
  '/billing': typeof GuardBillingIndexRoute
  '/customers': typeof GuardCustomersIndexRoute
  '/orders': typeof GuardOrdersIndexRoute
  '/products': typeof GuardProductsIndexRoute
  '/profile': typeof GuardProfileIndexRoute
  '/settings': typeof GuardSettingsIndexRoute
  '/products/$productId/edit': typeof GuardProductsProductIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_guard': typeof GuardRouteWithChildren
  '/coming-soon': typeof ComingSoonRoute
  '/terms': typeof TermsRoute
  '/ui': typeof UiRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/register': typeof AuthRegisterRoute
  '/billing/callback': typeof BillingCallbackRoute
  '/checkout/$token': typeof CheckoutTokenRoute
  '/instagram/callback': typeof InstagramCallbackRoute
  '/invite/$token': typeof InviteTokenRoute
  '/track/$uuid': typeof TrackUuidRoute
  '/_guard/': typeof GuardIndexRoute
  '/_auth/otp/verify': typeof AuthOtpVerifyRoute
  '/_guard/orders/$orderId': typeof GuardOrdersOrderIdRoute
  '/_guard/orders/create': typeof GuardOrdersCreateRoute
  '/_guard/products/create': typeof GuardProductsCreateRoute
  '/_guard/shops/create': typeof GuardShopsCreateRoute
  '/_guard/shops/instagram': typeof GuardShopsInstagramRoute
  '/_auth/otp/': typeof AuthOtpIndexRoute
  '/_guard/billing/': typeof GuardBillingIndexRoute
  '/_guard/customers/': typeof GuardCustomersIndexRoute
  '/_guard/orders/': typeof GuardOrdersIndexRoute
  '/_guard/products/': typeof GuardProductsIndexRoute
  '/_guard/profile/': typeof GuardProfileIndexRoute
  '/_guard/settings/': typeof GuardSettingsIndexRoute
  '/_guard/products/$productId/edit': typeof GuardProductsProductIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/coming-soon'
    | '/terms'
    | '/ui'
    | '/login'
    | '/register'
    | '/billing/callback'
    | '/checkout/$token'
    | '/instagram/callback'
    | '/invite/$token'
    | '/track/$uuid'
    | '/otp/verify'
    | '/orders/$orderId'
    | '/orders/create'
    | '/products/create'
    | '/shops/create'
    | '/shops/instagram'
    | '/otp/'
    | '/billing/'
    | '/customers/'
    | '/orders/'
    | '/products/'
    | '/profile/'
    | '/settings/'
    | '/products/$productId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/coming-soon'
    | '/terms'
    | '/ui'
    | '/login'
    | '/register'
    | '/billing/callback'
    | '/checkout/$token'
    | '/instagram/callback'
    | '/invite/$token'
    | '/track/$uuid'
    | '/otp/verify'
    | '/orders/$orderId'
    | '/orders/create'
    | '/products/create'
    | '/shops/create'
    | '/shops/instagram'
    | '/otp'
    | '/billing'
    | '/customers'
    | '/orders'
    | '/products'
    | '/profile'
    | '/settings'
    | '/products/$productId/edit'
  id:
    | '__root__'
    | '/_auth'
    | '/_guard'
    | '/coming-soon'
    | '/terms'
    | '/ui'
    | '/_auth/login'
    | '/_auth/register'
    | '/billing/callback'
    | '/checkout/$token'
    | '/instagram/callback'
    | '/invite/$token'
    | '/track/$uuid'
    | '/_guard/'
    | '/_auth/otp/verify'
    | '/_guard/orders/$orderId'
    | '/_guard/orders/create'
    | '/_guard/products/create'
    | '/_guard/shops/create'
    | '/_guard/shops/instagram'
    | '/_auth/otp/'
    | '/_guard/billing/'
    | '/_guard/customers/'
    | '/_guard/orders/'
    | '/_guard/products/'
    | '/_guard/profile/'
    | '/_guard/settings/'
    | '/_guard/products/$productId/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  GuardRoute: typeof GuardRouteWithChildren
  ComingSoonRoute: typeof ComingSoonRoute
  TermsRoute: typeof TermsRoute
  UiRoute: typeof UiRoute
  BillingCallbackRoute: typeof BillingCallbackRoute
  CheckoutTokenRoute: typeof CheckoutTokenRoute
  InstagramCallbackRoute: typeof InstagramCallbackRoute
  InviteTokenRoute: typeof InviteTokenRoute
  TrackUuidRoute: typeof TrackUuidRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_guard': {
      id: '/_guard'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof GuardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/coming-soon': {
      id: '/coming-soon'
      path: '/coming-soon'
      fullPath: '/coming-soon'
      preLoaderRoute: typeof ComingSoonRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ui': {
      id: '/ui'
      path: '/ui'
      fullPath: '/ui'
      preLoaderRoute: typeof UiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/register': {
      id: '/_auth/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_guard/': {
      id: '/_guard/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof GuardIndexRouteImport
      parentRoute: typeof GuardRoute
    }
    '/billing/callback': {
      id: '/billing/callback'
      path: '/billing/callback'
      fullPath: '/billing/callback'
      preLoaderRoute: typeof BillingCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout/$token': {
      id: '/checkout/$token'
      path: '/checkout/$token'
      fullPath: '/checkout/$token'
      preLoaderRoute: typeof CheckoutTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/instagram/callback': {
      id: '/instagram/callback'
      path: '/instagram/callback'
      fullPath: '/instagram/callback'
      preLoaderRoute: typeof InstagramCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/track/$uuid': {
      id: '/track/$uuid'
      path: '/track/$uuid'
      fullPath: '/track/$uuid'
      preLoaderRoute: typeof TrackUuidRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/otp/': {
      id: '/_auth/otp/'
      path: '/otp'
      fullPath: '/otp/'
      preLoaderRoute: typeof AuthOtpIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/otp/verify': {
      id: '/_auth/otp/verify'
      path: '/otp/verify'
      fullPath: '/otp/verify'
      preLoaderRoute: typeof AuthOtpVerifyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_guard/billing/': {
      id: '/_guard/billing/'
      path: '/billing'
      fullPath: '/billing/'
      preLoaderRoute: typeof GuardBillingIndexRouteImport
      parentRoute: typeof GuardRoute
    }
    '/_guard/customers/': {
      id: '/_guard/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof GuardCustomersIndexRouteImport
      parentRoute: typeof GuardRoute
    }
    '/_guard/orders/': {
      id: '/_guard/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof GuardOrdersIndexRouteImport
      parentRoute: typeof GuardRoute
    }
    '/_guard/orders/$orderId': {
      id: '/_guard/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof GuardOrdersOrderIdRouteImport
      parentRoute: typeof GuardRoute
    }
    '/_guard/orders/create': {
      id: '/_guard/orders/create'
      path: '/orders/create'
      fullPath: '/orders/create'
      preLoaderRoute: typeof GuardOrdersCreateRouteImport
      parentRoute: typeof GuardRoute
    }
    '/_guard/products/': {
      id: '/_guard/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof GuardProductsIndexRouteImport
      parentRoute: typeof GuardRoute
    }
    '/_guard/products/create': {
      id: '/_guard/products/create'
      path: '/products/create'
      fullPath: '/products/create'
      preLoaderRoute: typeof GuardProductsCreateRouteImport
      parentRoute: typeof GuardRoute
    }
    '/_guard/profile/': {
      id: '/_guard/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof GuardProfileIndexRouteImport
      parentRoute: typeof GuardRoute
    }
    '/_guard/settings/': {
      id: '/_guard/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof GuardSettingsIndexRouteImport
      parentRoute: typeof GuardRoute
    }
    '/_guard/shops/create': {
      id: '/_guard/shops/create'
      path: '/shops/create'
      fullPath: '/shops/create'
      preLoaderRoute: typeof GuardShopsCreateRouteImport
      parentRoute: typeof GuardRoute
    }
    '/_guard/shops/instagram': {
      id: '/_guard/shops/instagram'
      path: '/shops/instagram'
      fullPath: '/shops/instagram'
      preLoaderRoute: typeof GuardShopsInstagramRouteImport
      parentRoute: typeof GuardRoute
    }
    '/_guard/products/$productId/edit': {
      id: '/_guard/products/$productId/edit'
      path: '/products/$productId/edit'
      fullPath: '/products/$productId/edit'
      preLoaderRoute: typeof GuardProductsProductIdEditRouteImport
      parentRoute: typeof GuardRoute
    }
  }
}

interface AuthRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthOtpVerifyRoute: typeof AuthOtpVerifyRoute
  AuthOtpIndexRoute: typeof AuthOtpIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthOtpVerifyRoute: AuthOtpVerifyRoute,
  AuthOtpIndexRoute: AuthOtpIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface GuardRouteChildren {
  GuardIndexRoute: typeof GuardIndexRoute
  GuardOrdersOrderIdRoute: typeof GuardOrdersOrderIdRoute
  GuardOrdersCreateRoute: typeof GuardOrdersCreateRoute
  GuardProductsCreateRoute: typeof GuardProductsCreateRoute
  GuardShopsCreateRoute: typeof GuardShopsCreateRoute
  GuardShopsInstagramRoute: typeof GuardShopsInstagramRoute
  GuardBillingIndexRoute: typeof GuardBillingIndexRoute
  GuardCustomersIndexRoute: typeof GuardCustomersIndexRoute
  GuardOrdersIndexRoute: typeof GuardOrdersIndexRoute
  GuardProductsIndexRoute: typeof GuardProductsIndexRoute
  GuardProfileIndexRoute: typeof GuardProfileIndexRoute
  GuardSettingsIndexRoute: typeof GuardSettingsIndexRoute
  GuardProductsProductIdEditRoute: typeof GuardProductsProductIdEditRoute
}

const GuardRouteChildren: GuardRouteChildren = {
  GuardIndexRoute: GuardIndexRoute,
  GuardOrdersOrderIdRoute: GuardOrdersOrderIdRoute,
  GuardOrdersCreateRoute: GuardOrdersCreateRoute,
  GuardProductsCreateRoute: GuardProductsCreateRoute,
  GuardShopsCreateRoute: GuardShopsCreateRoute,
  GuardShopsInstagramRoute: GuardShopsInstagramRoute,
  GuardBillingIndexRoute: GuardBillingIndexRoute,
  GuardCustomersIndexRoute: GuardCustomersIndexRoute,
  GuardOrdersIndexRoute: GuardOrdersIndexRoute,
  GuardProductsIndexRoute: GuardProductsIndexRoute,
  GuardProfileIndexRoute: GuardProfileIndexRoute,
  GuardSettingsIndexRoute: GuardSettingsIndexRoute,
  GuardProductsProductIdEditRoute: GuardProductsProductIdEditRoute,
}

const GuardRouteWithChildren = GuardRoute._addFileChildren(GuardRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  GuardRoute: GuardRouteWithChildren,
  ComingSoonRoute: ComingSoonRoute,
  TermsRoute: TermsRoute,
  UiRoute: UiRoute,
  BillingCallbackRoute: BillingCallbackRoute,
  CheckoutTokenRoute: CheckoutTokenRoute,
  InstagramCallbackRoute: InstagramCallbackRoute,
  InviteTokenRoute: InviteTokenRoute,
  TrackUuidRoute: TrackUuidRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
